// URL <-> page mapping. The app keeps its own page state; these helpers keep
// the address bar in sync so pages (products especially) can be shared and the
// browser back button works. Netlify serves index.html for every path
// (public/_redirects), so any of these URLs can be opened directly.

const PAGE_PATHS = {
  home: "/",
  shop: "/collections",
  wishlist: "/wishlist",
  checkout: "/checkout",
  about: "/about",
  contact: "/contact",
};

const slugify = (text) =>
  String(text || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // é -> e
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// /product/mdb-0049-eternal-heart-silver-jewelry-set
// The SKU leads so the link survives a rename; the name is for humans.
export const productPath = (product) =>
  `/product/${slugify(product.sku)}-${slugify(product.name)}`;

export const pathFor = (page, product) =>
  page === "product-detail" && product
    ? productPath(product)
    : PAGE_PATHS[page] || "/";

// -> { page, sku }  (sku is upper-case, e.g. "MDB-0049", for product pages)
export const parsePath = (pathname) => {
  const path = pathname.replace(/\/+$/, "") || "/";

  const product = path.match(/^\/product\/([a-z]+-\d+)/i);
  if (product) return { page: "product-detail", sku: product[1].toUpperCase() };

  const page = Object.keys(PAGE_PATHS).find((p) => PAGE_PATHS[p] === path);
  return { page: page || "home", sku: null };
};

export const productUrl = (product) =>
  `${window.location.origin}${productPath(product)}`;
